import { statusColorMapping } from "../../../../../enums";

export const columns = [
  {
    title: 'Status',
    field: 'deliveryStatusValue',
    align: 'left',
    type: 'string',
    render: row => (
      <div style={{ color: statusColorMapping[row.deliveryStatus] || 'black' }}>{row.deliveryStatusValue}</div>
    ),
    disableSorting: true
  },
  {
    title: 'Creat de',
    field: 'createdBy',
    align: 'left',
    type: 'string',
    disableSorting: true
  },
  {
    title: 'Data crearii',
    field: 'created',
    align: 'left',
    type: 'string',
    disableSorting: true
  },
  {
    title: 'Actualizat de',
    field: 'updatedBy',
    align: 'left',
    type: 'string',
    disableSorting: true
  },
  {
    title: 'Ultima actualizare',
    field: 'updated',
    align: 'left',
    type: 'string',
    disableSorting: true
  }
]
